<template>
  <v-card flat>
    <v-card-title>
      <h4 class="earth-color">SCHEDULE PRICE SURGE</h4>
    </v-card-title>
    <v-container>
      <v-form  @submit.prevent="_addSurgeSchedule()">
        <v-layout row wrap>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-dialog
                ref="dialog"
                persistent
                v-model="modal"
                lazy
                full-width
                width="290px"
                :return-value.sync="surge.start_date"
              >
                <v-text-field
                  slot="activator"
                  label="Start Date"
                  v-model="surge.start_date"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="surge.start_date"
                  scrollable
                  :min="today"
                >
                  <v-spacer></v-spacer>
                  <v-btn :depressed="true" flat color="primary" @click="modal = false">Cancel</v-btn>
                  <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(surge.start_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-dialog
                ref="dialog1"
                persistent
                v-model="modal1"
                lazy
                full-width
                width="290px"
                :return-value.sync="surge.end_date"
              >
                <v-text-field
                  slot="activator"
                  label="End Date"
                  v-model="surge.end_date"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="surge.end_date"
                  scrollable
                  :min="today"
                >
                  <v-spacer></v-spacer>
                  <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
                  <v-btn :depressed="true" flat color="primary" @click="$refs.dialog1.save(surge.end_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 xs12 sm12>
            <v-container>
              <v-text-field
                label="Percentage Increase(%)"
                v-model="surge.percentage"
                type="number"
                min="0"
              ></v-text-field>
            </v-container>
          </v-flex>

          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-btn :depressed="true" color="primary" @click="_addSurgeSchedule" type="submit">Add Surge Schedule</v-btn>
            </v-container>
          </v-flex>
        </v-layout>
      </v-form>
      <div class="col-md-12">
        <table cellpadding="1" cellspacing="1" class="table table-bordered">
          <thead>
          <tr>
            <td>Start Date</td>
            <td>End Date</td>
            <td>Percentage</td>
           <!-- <td>Reason </td> -->
            <td>Action</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(schedule, key) in facilitySurge" :key="key">
            <td>{{formated_date(schedule.percentage_start_date)}}</td>
            <td>{{formated_date(schedule.percentage_end_date)}}</td>
            <td>{{schedule.pricing_percentage}}</td>
<!--            <td>{{// schedule.unavailability_reason}}</td>-->
            <td>
              <v-btn :depressed="true" small color="error" @click="_deleteSurgeSchedule(schedule.percentage_public_id)">X</v-btn>
              <!--<button class="btn btn-info btn-sm" @click="disableDiscount(d)">Edit</button>-->
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'PriceSurge',
  data () {
    return {
      dialog: false,
      dialog1: false,
      modal: false,
      modal1: false,
      today: this.$moment().format('YYYY-MM-DD'),
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      surge: {
        facility_id: this.$route.params.facility_id,
        start_date: '',
        end_date: '',
        percentage: '',
        reason: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  beforeCreate () {
    this.$store.dispatch('get_facility_surge_schedule', this.$route.params.facility_id)
  },
  methods: {
    _addSurgeSchedule () {
      this.$store.dispatch('post_facility_surge_schedule', this.surge)
    },
    _deleteSurgeSchedule (publicId) {
      this.$store.dispatch('remove_faiclity_surge_schedule', publicId)
    }
  }
}
</script>

<style scoped>

</style>
